/**
 *  Consultas (consultas/*) → /api/v1/reports
 *  Forma vieja: reportes {IdReporte, Nombre, Descripcion, Consulta}; filas del
 *  SP con las columnas excelColumnsShow/Name/Type repetidas en cada fila.
 *
 *  Koa ejecutaba el SP cuyo nombre venía en `Procedure`. v1 no expone nombres
 *  de SP: `Consulta` ahora trae el id del reporte y `execute` lo usa como id.
 */
import moment from 'moment-timezone';
import api, { download } from '../apiV1';
import { fail, list } from './index';

const day = (v) => (v ? moment(v).format('YYYY-MM-DD') : undefined);

// El Excel lo arma v1 con el último reporte que se consultó (la vista manda
// las filas ya armadas, pero el servidor ya no las acepta).
let lastRun = null;

export default {
   'GET consultas/get': async () => {
      const res = await api.get('reports');
      if (!res.ok) return fail(res);
      return list(
         (res.data || []).map((r) => ({
            IdReporte: r.id,
            Nombre: r.name,
            Descripcion: r.description,
            Consulta: String(r.id),
         }))
      );
   },

   'POST consultas/execute': async (data) => {
      const id = Number(data.Procedure);
      if (!id) return { error: true, message: 'Reporte no válido.' };
      const query = { from: day(data.Desde), to: day(data.Hasta) };
      const res = await api.get(`reports/${id}/data`, query);
      if (!res.ok) return fail(res);
      lastRun = { id, query, name: res.data.report.name };
      const cols = res.data.columns || [];
      const meta = {
         excelColumnsShow: cols.map((c) => c.key).join(','),
         excelColumnsName: cols.map((c) => c.label).join(','),
         excelColumnsType: cols.map((c) => c.type).join(','),
      };
      return list((res.data.rows || []).map((row) => ({ ...row, ...meta })));
   },

   'POST consultas/exportar/reporte': async () => {
      if (!lastRun) return { error: true, message: 'Genera el reporte antes de exportarlo.' };
      const res = await download(`reports/${lastRun.id}/export`, lastRun.query, `${lastRun.name}.xlsx`);
      return res.ok ? { downloaded: true } : { error: true, message: res.message };
   },
};
